export const environment = {
  production: true,
  assetsUrl: '../assets',
  version: require('../../package.json').version
};
